import { Editor } from 'grapesjs';
import { faText } from '@fortawesome/pro-solid-svg-icons/faText';
import { EditorComponentDefinition } from './types';
import {
  GrapesjsComponent,
  renderLocalizedComponent,
} from '../../helpers/render-localized-component';
import { Toolbar } from '../utils';
import { translateAttributes } from '../../services/copy-paste/copy-paste-utils';
import { updateI18nAttributes } from './i18n';

const CLASSNAME = 'qlfeditor-text';

export const textComponentDefinition: EditorComponentDefinition = {
  id: 'custom-text',
  icon: faText,
  category: 'Content',
  getLabel: ({ t }) => t('editor.component.text'),
  component: TextComponent,
  copyPasteHelper: (element, context) => translateAttributes(element, context.destinationLocales),
};

export function TextComponent(editor: Editor) {
  const languages: string[] = editor.Config?.context?.languages || [];
  const i18n = editor.I18n;

  editor.DomComponents.addType(textComponentDefinition.id, {
    extend: 'text',
    model: {
      defaults: {
        traits: [],
        i18nAttributes: {},
        attributes: {
          class: CLASSNAME,
        },
      },
      initToolbar: Toolbar,
    },
    view: {
      init({ model }: { model: any }) {
        // initialize the content of the component with the raw html placed in the window
        const content = this.model.getInnerHTML();

        languages.forEach(language => {
          if (!model.attributes.i18nAttributes?.[language]) {
            updateI18nAttributes.call(this, language, {
              content:
                // if someone gave initial html inside the <div data-gjs-type="custom-text">...</div>, it'll be used as the initial content
                content ||
                `<div class="ql-snow">
                    <div class="ql-editor">
                        <p>${i18n.t('editor.text.default', { l: language })}</p>
                    </div>
                </div>
                `,
            });
          }
        });

        this.listenTo(model, 'rte:disable', () => {
          this.getContent().then((content: string) => {
            updateI18nAttributes.call(this, i18n.getLocale(), { content });
          });
        });
      },
      onRender() {
        renderLocalizedComponent(this as GrapesjsComponent, i18n);
      },
    },
  });
}
